import { render, staticRenderFns } from "./DecisionCreator.vue?vue&type=template&id=a4e12c9a&scoped=true&"
import script from "./DecisionCreator.vue?vue&type=script&lang=ts&"
export * from "./DecisionCreator.vue?vue&type=script&lang=ts&"
import style0 from "./DecisionCreator.vue?vue&type=style&index=0&id=a4e12c9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e12c9a",
  null
  
)

export default component.exports